import React from "react";

// Eyebrow + serif H2 + lead paragraph, reused by most sections.
const SectionHeader = ({
  eyebrow,
  title,
  children,
  className = "vd-section-head",
}) => (
  <div className={className}>
    {eyebrow && <span className="vd-eyebrow">{eyebrow}</span>}
    <h2 className="vd-h2">{title}</h2>
    {children && <p className="vd-lead">{children}</p>}
  </div>
);

export default SectionHeader;
